import type { HTMLAttributes } from "react";

import {
  GRID_GAP_CLASS_MAP,
  GRID_RESPONSIVE_GAP_CLASS_MAP,
} from "@/ui/components/layout/Grid";
import type {
  BreakpointProp,
  DefinedDefaults,
  TWithDataComponent,
} from "@/ui/lib";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const AVAILABLE_INLINE_TAGS = [ "div", "ul", "ol", "article" ] as const;

export const INLINE_GAP_CLASS_MAP = GRID_GAP_CLASS_MAP;

export const INLINE_RESPONSIVE_GAP_CLASS_MAP = GRID_RESPONSIVE_GAP_CLASS_MAP;

/*-------------------------------------
|  Types
|-------------------------------------*/

type TInlineTag = typeof AVAILABLE_INLINE_TAGS[number];

export type TInlineGap = keyof typeof INLINE_GAP_CLASS_MAP;

export type TInlineGapProp =
  BreakpointProp<typeof INLINE_RESPONSIVE_GAP_CLASS_MAP>;

export type TInlineProps = {
  tag?: TInlineTag;
  gap?: TInlineGapProp;
} & TWithDataComponent & HTMLAttributes<HTMLElement>;

type TInlineDefaultProps = DefinedDefaults<
  TInlineProps,
  "data-component" | "gap" | "tag"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const INLINE_DEFAULTS = {
  tag: "div",
  gap: "4",
  "data-component": "Inline",
} satisfies TInlineDefaultProps;
